// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nwij","content":"styles_content__2XPZm","selectAll":"styles_selectAll__31WlD"};